import CallMadeIcon from '@mui/icons-material/CallMade';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import BuildIcon from '@mui/icons-material/Build';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import type { ReactElement, ReactNode } from 'react';

export type AgentToolRole = 'activity' | 'input' | 'output' | 'inputSchema' | 'outputSchema';

const roleMetadata: Record<AgentToolRole, { label: string; color: 'info' | 'success'; icon: ReactElement }> = {
	activity: { label: 'Agent tool', color: 'info', icon: <BuildIcon /> },
	input: { label: 'Tool input', color: 'info', icon: <CallReceivedIcon /> },
	output: { label: 'Tool output', color: 'success', icon: <CallMadeIcon /> },
	inputSchema: { label: 'Tool input schema', color: 'info', icon: <CallReceivedIcon /> },
	outputSchema: { label: 'Tool output schema', color: 'success', icon: <CallMadeIcon /> },
};

export default function AgentToolRoleChip({
	role,
	muted = false,
	endAdornment,
	onClick,
}: {
	role: AgentToolRole;
	muted?: boolean;
	endAdornment?: ReactNode;
	onClick?: () => void;
}) {
	const metadata = roleMetadata[role];
	return (
		<Chip
			size="small"
			icon={metadata.icon}
			onClick={onClick}
			label={
				<Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: endAdornment ? 0.5 : 0 }}>
					{metadata.label}
					{endAdornment}
				</Box>
			}
			color={muted ? 'default' : metadata.color}
			sx={{
				height: role === 'activity' ? 22 : 18,
				fontSize: role === 'activity' ? undefined : '0.65rem',
				opacity: muted ? 0.55 : 1,
				'& .MuiChip-label': { px: role === 'activity' ? 0.75 : 0.65 },
				'& .MuiChip-icon': { fontSize: role === 'activity' ? undefined : 13, ml: role === 'activity' ? undefined : 0.35, mr: role === 'activity' ? undefined : -0.15 },
			}}
		/>
	);
}
